// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2rI0k","modalForm":"UpgradeEpcsModal_modalForm__h_rTH","modalFooter":"UpgradeEpcsModal_modalFooter__QnX0W"};